import { invnumberConstants } from '../constants';

export function invnumber(state = {}, action) {
  switch (action.type) {
    case invnumberConstants.GET_INV_NUMBER_REQUEST:
      return {
        loading: true
      };
    case invnumberConstants.GET_INV_NUMBER_SUCCESS:
      return {
        ...state, invnumber: action.data
      };
    case invnumberConstants.GET_INV_NUMBER_FAILURE:
      return {
        error: action.error
      };
    case invnumberConstants.GET_INV_NUMBER_JURISDICTIONS_REQUEST:
      return {
        loading: true
      };
    case invnumberConstants.GET_INV_NUMBER_JURISDICTIONS_SUCCESS:
      return {
        ...state, jurisdictions: action.data
      };
    case invnumberConstants.GET_INV_NUMBER_JURISDICTIONS_FAILURE:
      return {
        error: action.error
      };
    case invnumberConstants.GET_INV_NUMBER_CITIES_REQUEST:
      return {
        loading: true
      };
    case invnumberConstants.GET_INV_NUMBER_CITIES_SUCCESS:
      return {
        ...state, cities: action.data
      };
    case invnumberConstants.GET_INV_NUMBER_CITIES_FAILURE:
      return {
        error: action.error
      };
    case invnumberConstants.GET_INV_NUMBERS_SUCCESS:
      return {
        ...state, invnumbers: action.data
      }
    case invnumberConstants.GET_INV_NUMBERS_FAILURE:
      return {
        error: action.error
      };
    case invnumberConstants.GET_INV_NUMBERS_COVERAGE_REQUEST:
      return {
        loading: true
      };
    case invnumberConstants.ADD_INV_NUMBER_REQUEST:
      return {
        loading: true
      };
    case invnumberConstants.ADD_INV_NUMBER_SUCCESS:
      return {
        ...state
      };
    case invnumberConstants.ADD_INV_NUMBER_FAILURE:
      return {
        error: action.error
      };
    case invnumberConstants.ADD_BULK_INV_NUMBER_REQUEST:
      return {
        bulkloading: true
      };
    case invnumberConstants.ADD_BULK_INV_NUMBER_SUCCESS:
      return {
        ...state, bulkresults: action.data.data, bulkloading: undefined
      };
    case invnumberConstants.ADD_BULK_INV_NUMBER_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}
